import * as go from 'gojs';
import { realPorts, virtualPorts } from '../common/parts/port';
import {
  angleBinding,
  borderColorBinding,
  geometryStringBinding,
  locationBinding,
  lockedBindings,
  sizeBinding,
  zOrderBindings,
} from '../common/utils/bindings';
import { borderWidthBinding, lineStyleBinding } from './../common/utils/bindings';
import { FREE_DRAW_NODE_MAIN_SHAPE_NAME } from './config/part-names';

const $ = go.GraphObject.make;

const movable = true;
const resizable = true;
const rotatable = true;

export const freeDrawNodeTemplate = () =>
  $(
    go.Node,
    go.Panel.Spot,
    {
      isShadowed: true,
      resizeObjectName: FREE_DRAW_NODE_MAIN_SHAPE_NAME,
      selectionObjectName: FREE_DRAW_NODE_MAIN_SHAPE_NAME,
      locationObjectName: FREE_DRAW_NODE_MAIN_SHAPE_NAME,
      isLayoutPositioned: false,
      locationSpot: go.Spot.TopLeft,
      toolTip: null,
      rotationSpot: go.Spot.Center,
      background: 'transparent',
      movable,
      resizable,
      rotatable,
    },
    shape(),
    locationBinding(),
    angleBinding(),
    ...lockedBindings({ movable, resizable, rotatable }),
    ...zOrderBindings(),
    ...virtualPorts(),
    ...realPorts(),
  );

const shape = () =>
  $(
    go.Shape,
    {
      name: FREE_DRAW_NODE_MAIN_SHAPE_NAME,
      fill: null,
      strokeCap: 'round',
      strokeJoin: 'round',
    },
    geometryStringBinding(),
    sizeBinding(),
    borderColorBinding(),
    borderWidthBinding(),
    lineStyleBinding(),
  );
